import { useCallback } from 'react'

export function useAiAskBarGallery({
  imageAttachments,
  setAttachmentGallerySession,
  setAttachmentGalleryInitialIndex,
  setAttachmentGalleryOpen,
}) {
  const openAttachmentGalleryAtId = useCallback(
    (id) => {
      const idx = imageAttachments.findIndex((a) => a.id === id)
      if (idx < 0) return
      setAttachmentGallerySession((s) => s + 1)
      setAttachmentGalleryInitialIndex(idx)
      setAttachmentGalleryOpen(true)
    },
    [imageAttachments, setAttachmentGalleryInitialIndex, setAttachmentGalleryOpen, setAttachmentGallerySession],
  )

  return { openAttachmentGalleryAtId }
}
